import type { AttendanceEmployeeRow } from "./attendance-types";

export type AttendanceFooterStats = {
  employeeCount: number;
  avgPresentRate: number | null;
  withAbsentCount: number;
  withIncompleteCount: number;
  totalHours: number;
};

/**
 * Lightweight department strip: present rate = present / working days, averaged across staff
 * who have workingDaysInMonth > 0.
 */
export function computeAttendanceFooterStats(rows: AttendanceEmployeeRow[]): AttendanceFooterStats {
  const employeeCount = rows.length;
  let withAbsentCount = 0;
  let withIncompleteCount = 0;
  let totalHours = 0;
  let presentRateSum = 0;
  let presentRateCount = 0;

  for (const row of rows) {
    const {
      presentDays,
      absentDays,
      incompleteDays,
      workingDaysInMonth,
      totalHours: hours,
    } = row.summary;
    if (absentDays >= 1) withAbsentCount += 1;
    if (incompleteDays >= 1) withIncompleteCount += 1;
    totalHours += hours;
    if (workingDaysInMonth > 0) {
      presentRateSum += presentDays / workingDaysInMonth;
      presentRateCount += 1;
    }
  }

  return {
    employeeCount,
    avgPresentRate: presentRateCount > 0 ? presentRateSum / presentRateCount : null,
    withAbsentCount,
    withIncompleteCount,
    totalHours: Math.round(totalHours * 100) / 100,
  };
}

export function formatPresentRatePercent(rate: number | null): string {
  if (rate == null || !Number.isFinite(rate)) return "—";
  return `${Math.round(rate * 1000) / 10}%`;
}
